import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import { PlacementCreateManager } from 'UI/components/organisms/placements/PlacementCreateManager';

export const CreatePlacementDrawer = ({
  companyId,
  jobOrderId,
  sendoutId,
  onClose = () => {},
  onCompleted = () => {},
  onNewSendout = () => {}
}) => {
  const handleNewSendoutClick = () => {
    onClose();
    onNewSendout();
  };

  return (
    <Drawer open onClose={onClose}>
      <PlacementCreateManager
        sendoutId={Number(sendoutId)}
        jobOrderId={jobOrderId}
        companyId={companyId}
        onClose={onClose}
        onCompleted={onCompleted}
        onNewSendoutClick={handleNewSendoutClick}
      />
    </Drawer>
  );
};
